if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          prevButton: this.querySelector('.slider-button--prev'), // Previous button
          nextButton: this.querySelector('.slider-button--next'), // Next button
        };

        if (!this.elements.thumbnails) return;

        // Event listeners for the prev/next buttons
        if (this.elements.prevButton) {
          this.elements.prevButton.addEventListener('click', this.showPreviousMedia.bind(this));
        }

        if (this.elements.nextButton) {
          this.elements.nextButton.addEventListener('click', this.showNextMedia.bind(this));
        }

        // Add click event listeners to each thumbnail
        this.elements.thumbnails.querySelectorAll('button').forEach((thumbnail) => {
          thumbnail.addEventListener('click', (event) => {
            const mediaId = event.currentTarget.closest('[data-target]').dataset.target;
            this.setActiveMedia(mediaId);  // Change main image when thumbnail is clicked
          });
        });

        // Initial setup
        this.updateNavigationButtons(); // Initially hide/show buttons based on the current slide

        // Listener for when the slide is changed
        this.elements.viewer.addEventListener('slideChanged', this.updateNavigationButtons.bind(this));

        // Set the initial active thumbnail
        this.updateThumbnails(); // Sync thumbnails with the main image
      }

      // Function to show the previous media
      showPreviousMedia() {
        const currentActive = this.elements.viewer.querySelector('.is-active');
        const previousMedia = currentActive.previousElementSibling;

        if (previousMedia) {
          this.setActiveMedia(previousMedia.dataset.mediaId);
          this.updateNavigationButtons(); 
        }
      }

      // Function to show the next media
      showNextMedia() {
        const currentActive = this.elements.viewer.querySelector('.is-active');
        const nextMedia = currentActive.nextElementSibling;

        if (nextMedia) {
          this.setActiveMedia(nextMedia.dataset.mediaId);
          this.updateNavigationButtons(); // Update the button states
        }
      }

      // Function to update the visibility/enabling of the prev/next buttons
      updateNavigationButtons() {
        const currentActive = this.elements.viewer.querySelector('.is-active');

        // Disable/Hide "Previous" button if it's the first image
        if (!currentActive.previousElementSibling) {
          this.elements.prevButton.style.display = 'none'; // Hide the previous button
        } else {
          this.elements.prevButton.style.display = 'block'; // Show the previous button
        }

        // Disable/Hide "Next" button if it's the last image
        if (!currentActive.nextElementSibling) {
          this.elements.nextButton.style.display = 'none'; // Hide the next button
        } else {
          this.elements.nextButton.style.display = 'block'; // Show the next button
        }
      }

      // Function to set the active media by mediaId
      setActiveMedia(mediaId) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        // Remove "is-active" class from all media elements
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        // Add "is-active" class to the newly selected media
        activeMedia.classList.add('is-active');

        // Scroll into view if necessary
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        // Sync the thumbnails with the active media
        this.updateThumbnails();

        this.updateNavigationButtons(); // Update buttons when media changes
      }

      // Function to update the active thumbnail
      updateThumbnails() {
        const currentActive = this.elements.viewer.querySelector('.is-active');

        // Remove "is-active" class from all thumbnails
        this.elements.thumbnails.querySelectorAll('button').forEach((thumbnail) => {
          thumbnail.removeAttribute('aria-current');
        });

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${currentActive.dataset.mediaId}"]`);

        if (activeThumbnail) {
          activeThumbnail.querySelector('button').setAttribute('aria-current', 'true');

          
          if (!this.elements.thumbnails.isSlideVisible(activeThumbnail, 10)) {
            this.elements.thumbnails.slider.scrollTo({ left: activeThumbnail.offsetLeft });
          }
        }
      }
    }
  );
}
